import { Component } from '@angular/core';
import { SettingsEntry } from '../../components/pages/settings.page';
import { InjectorHelper } from '../../helpers/injector.helper';
import { MetaService } from '../../services/meta.service';
import { ERDEditSettings } from './edit/erd.edit.settings';
import { ERDOverviewSettings } from './overview/erd.overview.settings';

@Component({
    selector: 'erd-settings',
    template: '<div></div>',
    styleUrls: ['./erd.settings.css']
})
export class ERDSettings {

    private static SettingsEntry: SettingsEntry = {
        Caption: '@@ERD',
        ID: 'erd',
        Icon: 'erd',
        Index: 0,
        Parent: 'data',
        Security: {
            Name: 'evidanza.App.Shared.Security.DataRight',
            Value: 2
        },
        Children: [],
        UpdateFunction: ERDSettings.UpdateEntries
    };

    static UpdateEntries() {
        return new Promise<void>(resolve => {
            const service = InjectorHelper.InjectorInstance.get<MetaService>(MetaService);
            service.ReadERDs().subscribe((result) => {
                const list: any = [{
                    Caption: '@@Overview',
                    ID: 'overview',
                    Icon: 'erd',
                    Index: 0,
                    Parent: 'erd',
                    Security: {
                        Name: 'evidanza.App.Shared.Security.DataRight',
                        Value: 2
                    },
                    Content: ERDOverviewSettings
                }];

                if (result) {
                    for (let i = 0; i < result.length; i++) {
                        const item = result[i];
                        const entry = {
                            Caption: item.Caption,
                            ID: item._Id,
                            Icon: 'erd',
                            Index: i + 1,
                            Parent: 'erd',
                            Security: {
                                Name: 'evidanza.App.Shared.Security.DataRight',
                                Value: 2
                            },
                            InitArgs: { ID: item._Id },
                            Content: ERDEditSettings
                        };
                        list.push(entry);
                    }
                }
                ERDSettings.SettingsEntry.Children = list;
                resolve();
            });
        });
    }

    //static GetSettingsEntry() {
    //   ERDSettings.UpdateEntries();
    //   return ERDSettings.SettingsEntry;
    //}
}